import React from 'react';
import { mapModifiers } from 'libs/component';
import numeral from 'numeral';

export interface DistanceTextProps {
  distance: number;
  unit: string;
  children?: React.ReactNode;
}

// export const DistanceText: React.FC<DistanceTextProps> = ({ distance = 0.0, unit = 'km', children }) => (
  export const DistanceText: React.FC<DistanceTextProps> = ({ distance = 0.0, children }) => (
  <div className={mapModifiers('a-distance-text')}>
    {children}
    <span className="a-distance-text__value">
      {/* {numeral(distance).format('0.0')} {unit} */}
      {numeral(distance).format('0.0')} 公里
    </span>
  </div>
);
